import isDuiTang from './isDuiTang';
import isNaiYou from './isNaiYou';

// 判断是否在 APP 内，堆糖 或 奶由壁纸皆可
const isInApp = (): boolean => {
  return isDuiTang() || isNaiYou();
};

export default isInApp;
